<template>
  <div class="pc-course-series">
    <div class="pc-course-series-header">
      <h2>评审委员会</h2>
      <div class="pc-button-group">
        <el-button
          v-show="isEditting == true"
          class="pc-btn distributionbtn"
          @click="distribution1()"
        >
          第一轮自动分配
        </el-button>
        <el-button
          v-show="isEditting == true"
          class="pc-btn distributionbtn"
          @click="distribution2()"
        >
          第二轮自动分配
        </el-button>
        <el-button
          v-show="isEditting == true"
          class="pc-btn distributionbtn"
          @click="distribution3()"
        >
          第三轮自动分配
        </el-button>
        <el-button
          v-show="isEditting == true"
          class="pc-btn distributionbtn"
          @click="exportJudge"
        >
          导出本轮评委
        </el-button>
        <el-button
          v-show="isEditting == true"
          class="pc-btn addbtn"
          @click="addPerson"
        >
          添加
        </el-button>
        <el-button
          @click="manageSeries"
          v-show="isEditting == false"
          class="pc-btn"
        >
          管理
        </el-button>
        <el-button @click="save" v-show="isEditting" class="pc-btn">
          完成
        </el-button>
      </div>
    </div>
    <ul class="series-list">
      <li
        v-for="(item, index) in commiteeList"
        :key="index"
        class="series-item"
        :class="{ active: isEditting == true }"
        @click="goSeriesPage(item)"
      >
        <div class="series-item-image">
          <img :src="item.profile_image" alt="" />
        </div>
        <div class="series-item-content">
          <p class="name">名称：{{ item.chinese_name }}</p>
          <p class="name">用户名：{{ item.judge_username }}</p>
          <p class="name">密码：{{ item.judge_password }}</p>
        </div>

        <!-- 点击编辑显示的删除样式 -->
        <div
          v-show="isEditting"
          @click="deleteSeries(item)"
          class="choice-delete"
        >
          <i class="el-icon-circle-close"></i>
        </div>
      </li>
    </ul>
    <div class="pc-course-series-header1">
      <div class="pc-course-series-body">
        <h4>评审轮次</h4>
        <el-select
          style="width: 300px"
          :disabled="!isEditting"
          v-model="judgeAllow.round"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in roundList"
            :key="index"
            :label="item.round"
            :value="item.round"
          ></el-option>
        </el-select>
      </div>
      <div class="pc-course-series-body">
        <h4>评委名称</h4>
        <el-select
          style="width: 300px"
          :disabled="!isEditting"
          v-model="judgeAllow.judge_username"
          placeholder="请选择"
          value-key="judge_id"
        >
          <el-option
            v-for="(item, index) in commiteeList"
            :key="index"
            :label="item.judge_username"
            :value="item.judge_username"
          ></el-option>
        </el-select>
      </div>

      <div class="pc-button-group">
        <el-button v-show="isEditting" @click="deleteJudges()" class="pc-btn">
          清空
        </el-button>
        <el-button v-show="isEditting" class="pc-btn addbtn" @click="addJudge">
          添加
        </el-button>
        <el-button v-show="isEditting" @click="queryJudge()" class="pc-btn">
          查询
        </el-button>
      </div>
    </div>
    <ul class="series-list">
      <li
        v-for="(item, index) in judgeAllow_list"
        :key="index"
        class="series-item"
        :class="{ active: isEditting == true }"
      >
        <div class="series-item-image">
          <img :src="item.cover_image" alt="" />
        </div>
        <div class="series-item-content">
          <p class="name">{{ item.chinese_name }}</p>
          <p class="name">{{ item.english_name }}</p>
        </div>

        <!-- 点击编辑显示的删除样式 -->
        <!-- v-show="isEditting" -->
        <div
          v-show="isEditting"
          @click="deleteWorks(item)"
          class="choice-delete"
        >
          <i class="el-icon-circle-close"></i>
        </div>
      </li>
    </ul>

    <el-dialog class="designerDialog" :visible.sync="isShowing" width="30%">
      <el-form label-width="80px">
        <el-form-item label="评审轮次">
          <el-select
            style="width: 80%"
            :disabled="!isEditting"
            v-model="exportJudges.round"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in roundList"
              :key="index"
              :label="item.round"
              :value="item.round"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-footer-button-one" @click="isShowing = false"
          >取 消</el-button
        >
        <el-button
          class="dialog-footer-button-second"
          type="primary"
          @click="submitBanner1(exportJudges)"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog class="designerDialog" :visible.sync="isShow" width="30%">
      <el-form label-width="80px">
        <el-form-item label="作品">
          <el-select
            style="min-width: 60%"
            v-model="judgeAllow.works_id"
            placeholder="请选择"
            value-key="id"
          >
            <el-option
              v-for="(item, index) in worksList"
              :key="index"
              :label="item.chinese_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-footer-button-one" @click="isShow = false"
          >取 消</el-button
        >
        <el-button
          class="dialog-footer-button-second"
          type="primary"
          @click="submitBanner(judgeAllow)"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <CommitteeDialog
      v-if="dialogVisiblePerson"
      :dialogVisible="dialogVisiblePerson"
      :committee="committee"
      @close="dialogVisiblePerson = false"
      @getList="getCommitteeList"
    />
    <DeleteDialog
      :dialogVisible="deleteDialogVisible"
      @isCancel="closeDelete"
      @isDelete="deleteConfirm"
    />
    <DeleteDialog1
      :dialogVisible="deleteDialogVisible1"
      @isCancel="closeDelete1"
      @isDelete="deleteJudge"
    />
  </div>
</template>

<script>
import DeleteDialog from "../../../componentSet/DeleteDialog";
import DeleteDialog1 from "./DeleteDialog1";
import CommitteeDialog from "./CommitteeDialog.vue";
import {
  CompetitionJudges_Api,
  deleteCompetitionJudges_Api,
  updateCompetitionAllow_Api,
  clearCompetitionJudges_Api,
  getCompetitionAllow_Api,
  competitionAllow_Api,
  competitionWorkList_Api,
  deleteCompetitionAllow_Api,
  competitionJudgeOutput_Api,
} from "../../../../apis/competition.api";
export default {
  data() {
    return {
      isEditting: false,
      isUpdateShow: false,
      isShow: false,
      isShowing: false,
      dialogVisiblePerson: false,
      deleteDialogVisible: false,
      deleteDialogVisible1: false,
      commiteeList: [],
      page: 1,
      total: 0,
      deleteSeriesId: 0,
      deleteSeriesUsername: "",
      deleteWorksId: 0,
      committee: {},
      judgeAllow: {
        competition_id: null,
        works_id: null,
        judge_username: null,
        round: null,
      },
      worksList: [],
      judgelist: [],
      judgeAllow_list: [],
      roundList: [{ round: 1 }, { round: 2 }, { round: 3 }],
      exportJudges: {
        competition_id: null,
        round: null,
      },
    };
  },
  components: {
    DeleteDialog,
    CommitteeDialog,
    DeleteDialog1,
  },
  mounted() {
    this.getCommitteeList("评委获取成功");
    this.getWorksList();
  },
  methods: {
    submitBanner() {
      if (
        this.judgeAllow.judge_username == null ||
        this.judgeAllow.round == null
      ) {
        this.$global.error(this, "请选择评审轮次和评委名称");
        return;
      } else {
        this.judgeAllow.competition_id = +this.$route.query.id;
        updateCompetitionAllow_Api(this.judgeAllow).then((res) => {
          if (res.msg == "exists") {
            this.$global.error(this, "该作品已添加");
            return;
          } else {
            this.isShow = false;
            this.$global.success(this, "修改成功");
            console.log(res);
            this.queryJudge();
          }
        });
      }
    },
    getWorksList() {
      competitionWorkList_Api({
        submit:1,
        pre_audit:1,
        page_size:1000,
        competition_id: this.$route.query.id,
        order: "+works_code",
      }).then((res) => {
        this.worksList = res.data;

        console.log(res);
      });
    },
    submitBanner1() {
      this.exportJudges.competition_id = +this.$route.query.id;
      competitionJudgeOutput_Api(this.exportJudges).then((res) => {
        this.$global.downloadFile(res, "judgelist");
        console.log(res);
      });
      this.isShowing = false;
    },
    exportJudge() {
      this.isShowing = true;
    },
    addJudge() {
      this.isShow = true;
    },
    deleteWorks(item) {
      console.log(item);
      this.deleteWorksId = item.id;
      this.deleteDialogVisible1 = true;
    },
    deleteJudge() {
      this.judgeAllow.competition_id = +this.$route.query.id;
      this.judgeAllow.works_id = this.deleteWorksId;
      deleteCompetitionAllow_Api({
        competition_id: this.judgeAllow.competition_id,
        judge_username: this.judgeAllow.judge_username,
        round: this.judgeAllow.round,
        works_id: this.judgeAllow.works_id,
      }).then((res) => {
        if (res.code == 404) {
          this.$global.error(this, "该作品已打分");
          return;
        }
        this.queryJudge();
        this.deleteDialogVisible1 = false;
        this.$global.success(this, "删除成功");
      });
    },
    deleteJudges() {
      clearCompetitionJudges_Api({
        competition_id: + this.$route.query.id,
        judge_username: this.judgeAllow.judge_username,
        round: this.judgeAllow.round,
      }).then((res) => {
        if (res.code == 404) {
          this.$global.error(this, "该作品已打分");
          return;
        }
        this.queryJudge();
        this.deleteDialogVisible1 = false;
        this.$global.success(this, "删除成功");
      });
    },
    queryJudge() {
      if (
        this.judgeAllow.judge_username == null ||
        this.judgeAllow.round == null
      ) {
        this.$global.error(this, "请选择评审轮次和评委名称");
        return;
      } else {
        competitionAllow_Api(
          this.judgeAllow.judge_username,
          this.$route.query.id,
          this.judgeAllow.round
        ).then((res) => {
          this.judgeAllow_list = res.data;
          console.log(res);
        });
      }
    },
    distribution1() {
      getCompetitionAllow_Api({
        competition_id: +this.$route.query.id,
        round: 1,
      }).then((res) => {
        if (res.msg == "ok") {
          this.$global.success(this, "分配成功");
        } else if (res.msg == "exists") {
          this.$global.error(this, "已经分配");
          return;
        } else if (res.msg == "grouped error") {
          this.$global.error(this, "分组必须是连续数字");
        }
        console.log(res);
      });
    },
    distribution2() {
      getCompetitionAllow_Api({
        competition_id: +this.$route.query.id,
        round: 2,
      }).then((res) => {
        if (res.msg == "ok") {
          this.$global.success(this, "分配成功");
        } else if (res.msg == "exists") {
          this.$global.error(this, "已经分配");
          return;
        } else if (res.msg == "grouped error") {
          this.$global.error(this, "分组必须是连续数字");
        }
        console.log(res);
      });
    },
    distribution3() {
      getCompetitionAllow_Api({
        competition_id: +this.$route.query.id,
        round: 3,
      }).then((res) => {
        if (res.msg == "ok") {
          this.$global.success(this, "分配成功");
        } else if (res.msg == "exists") {
          this.$global.error(this, "已经分配");
          return;
        } else if (res.msg == "grouped error") {
          this.$global.error(this, "分组必须是连续数字");
        }
        console.log(res);
      });
    },
    addPerson() {
      this.committee = {};
      this.committee.methods = "add";
      this.dialogVisiblePerson = true;
    },
    goSeriesPage(item) {
      if (this.isEditting && this.deleteDialogVisible == false) {
        this.committee = item;
        this.committee.methods = "update";
        this.dialogVisiblePerson = true;
        console.log(this.committee);
      }
    },
    getCommitteeList() {
      CompetitionJudges_Api(this.$route.query.id).then((res) => {
        this.commiteeList = res.data;
        console.log(res);
      });
    },

    manageSeries() {
      this.isEditting = true;
    },
    save() {
      this.isEditting = false;
    },
    deleteSeries(item) {
      console.log(item);
      this.deleteSeriesId = item.judge_id;
      this.deleteSeriesUsername = item.judge_username;
      this.deleteDialogVisible = true;
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    closeDelete1() {
      this.deleteDialogVisible1 = false;
    },

    deleteConfirm() {
      deleteCompetitionJudges_Api({
        judge_id: this.deleteSeriesId,
        judge_username: this.deleteSeriesUsername,
        competition_id: +this.$route.query.id,
      }).then((res) => {
        if(res.msg == "judge has been assigned works"){
          this.$global.error(this, "该评委已分配了作品，不能删除");
          return
        }else{
          this.getCommitteeList();
          this.deleteDialogVisible = false;
          this.$global.success(this, "删除成功");
        }
      });
    },
  },
};
</script>

<style scoped lang='scss'>
/deep/ .el-dialog__footer {
  .dialog-footer-button-one {
    @include manage-button;
    background: $test;
    color: $blueBtna;
  }
  .dialog-footer-button-second {
    @include manage-button;
  }
}
.pc-course-series {
  @include box-model;
  // min-height: 320px;
  .pc-course-series-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #c0c0c0;
    > h2 {
      font-size: 20px;
      padding-bottom: 15px;
      color: $mainTitle;
    }
    .pc-button-group {
      margin-top: -10px;
      .pc-btn {
        @include manage-button;
      }
      .addbtn {
        background: $test;
        color: $blueBtna;
      }
      .distributionbtn {
        background: $test;
        color: $blueBtna;
        width: 200px;
      }
    }
  }
  .pc-course-series-header1 {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #c0c0c0;
    .pc-course-series-body {
      display: flex;
      align-items: center;
      margin: 0 20px 10px 0;
      h4 {
        margin-right: 10px;
      }
    }
    > h2 {
      font-size: 20px;
      padding-bottom: 15px;
      // margin-right: 20px;
      color: $mainTitle;
    }
    .pc-button-group {
      margin-top: -10px;
      .pc-btn {
        @include manage-button;
      }
      .addbtn {
        background: $test;
        color: $blueBtna;
      }
      .distributionbtn {
        background: $test;
        color: $blueBtna;
        width: 200px;
      }
    }
  }

  .series-list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    margin-top: 30px;
    min-height: 150px;
    .series-item {
      position: relative;
      width: 25%;
      margin-right: 0.6%;
      height: 80px;
      border-radius: 4px;
      border: 1px solid #000000;
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      cursor: pointer;
      .series-item-image {
        width: 30%;
        margin: auto 0;
        img {
          width: 52px;
          height: 52px;
          border-radius: 50%;
          margin: 3px 0 0 3px;
        }
      }
      .series-item-content {
        width: 70%;
        padding: 11px 10px 0 11px;
        .name {
          @include ellipsis;
          width: 100%;
          height: 14px;
          margin-bottom: 10px;
          font-size: 14px;
          font-weight: 400;
          color: #434343;
          line-height: 14px;
        }
        .number {
          margin: 0;
          font-size: 10px;
          margin-top: 12px;
          span {
            display: inline-block;
            height: 14px;
            line-height: 14px;
            color: $lightenYellow;
          }
        }
      }
      .choice-delete {
        position: absolute;
        right: 0;
        border-radius: 0px 4px 4px 0;

        /deep/ .el-icon-circle-close {
          background: white;
          color: black;
          margin: -5px 0 0 30px;
        }
        /deep/ .el-icon-circle-close:hover {
          color: $lightenYellow;
        }
      }
    }
    .active:hover {
      transform: translateY(-20px);
      transition: 0.6s;
    }
  }

  // // 课程系列换页
  .pagination {
    display: flex;
    justify-content: center;
    li {
      cursor: pointer;
      width: 34px;
      height: 5px;
      background: $schoolTagBorder;
      margin-right: 10px;
    }
    .choicePage {
      background: $blueBtna;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/competition/components/CompetitionCommittee.vue